import { render, staticRenderFns } from "./ChangeRecord.vue?vue&type=template&id=4a4f3877"
import script from "./ChangeRecord.vue?vue&type=script&lang=js"
export * from "./ChangeRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports